import { render } from "./ManagerPunch.vue?vue&type=template&id=6ab80475&scoped=true"
import script from "./ManagerPunch.vue?vue&type=script&lang=js"
export * from "./ManagerPunch.vue?vue&type=script&lang=js"

import "./ManagerPunch.vue?vue&type=style&index=0&id=6ab80475&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab80475"]])

export default __exports__